import { render, staticRenderFns } from "./JbManTacografoOpcoes.vue?vue&type=template&id=49d1fb24&"
import script from "./JbManTacografoOpcoes.vue?vue&type=script&lang=js&"
export * from "./JbManTacografoOpcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports